  (function () {
    if (window.__hlMixpanel) return;
    window.__hlMixpanel = true;

    /* Liquid's half of this snippet now arrives as JSON in the page; the code is
       cached as an asset. Empty on a parse failure, and every branch below treats
       a missing value the same way it treated a page with no product. */
    var DATA = {};
    try { DATA = JSON.parse(document.getElementById('hl-mixpanel-data').textContent); } catch (e) {}

    /* Snapshot the landing URL and referrer NOW, at parse time.

       Mixpanel does not initialise until Shopify's privacy API has answered,
       which can be well after this script runs — and the storefront rewrites
       its own query string in that window. Measured: an Instagram click landing with
       utm_source + utm_medium + utm_campaign had only utm_source left by the
       time init ran, so the visit classified as a vague "Campaign" instead of
       "Paid Social" and lost the campaign name entirely.

       document.referrer is captured for the same reason: it is stable today,
       but reading both from one snapshot means attribution can never depend on
       how long the privacy lookup took. */
    /* Still a PARSE-TIME snapshot, for the reason above — but taken by the inline
       two-liner in hl-mixpanel.liquid, because this file is deferred and would
       otherwise read the query string after the storefront had already rewritten
       it. The fallback is for a page that somehow loses the inline tag. */
    var LANDING = window.__hlLanding || { search: location.search, referrer: document.referrer };
    var LANDING_SEARCH = LANDING.search;
    var LANDING_REFERRER = LANDING.referrer;

    var TOKEN = '5bbb46460e08b8e12adbb81598d598ff';
    var SHOP_CURRENCY = DATA.shop_currency;

    function ls(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }

    /* ---------- capture first, decide later ----------
       The wrapper goes on immediately, before Mixpanel boots. The privacy lookup
       takes up to 3s plus a script load, and this snippet renders at the end of
       <body> while blog read-depth events can fire earlier — anything not
       buffered in that window would be lost. Events queue here and are flushed
       in order once Mixpanel is up, or dropped silently on the hl_internal
       opt-out (the only gate left; Vietnam is labelled internal, not dropped). Cap
       of 100 so a page that fires in a loop cannot grow the array without
       bound. */
    var queue = [];
    var ready = false;
    var blocked = false;

    /* The page this DOCUMENT is, as opposed to the page localStorage last heard
       about.

       Super properties are stored per origin, not per tab. If a shopper has a
       product page and an FAQ page open at the same time, whichever tab last
       registered its super properties can stamp the other tab's late events.
       These values live in this document's closure and are merged under the
       event's own params, so deliberate event-level product data still wins. */
    var NONE = '(none)';
    /* undefined has to be in this test, not just null. Liquid emitted `null` for a
       page with no product, and it still does — but the values now arrive through a
       JSON tag, and if that tag is ever missing DATA stays {} and every lookup is
       undefined. Without this, five super properties would register the literal
       string "undefined" rather than '(none)', which is exactly the silent
       (not true) the comment above is about. */
    function liquidScope(v) { return (v === null || v === undefined || v === '') ? NONE : String(v); }
    var PAGE_SCOPE = {
      page_path: null,
      page_title: null,
      page_type: DATA.template,
      product_id: liquidScope(DATA.product_id),
      product_handle: liquidScope(DATA.product_handle),
      product_title: liquidScope(DATA.product_title),
      collection_handle: liquidScope(DATA.collection_handle),
      article_handle: liquidScope(DATA.article_handle)
    };

    function withScope(props) {
      var out = {}, k;
      for (k in PAGE_SCOPE) {
        if (Object.prototype.hasOwnProperty.call(PAGE_SCOPE, k)) out[k] = PAGE_SCOPE[k];
      }
      out.page_path = location.pathname;
      out.page_title = document.title;
      for (k in props) {
        if (Object.prototype.hasOwnProperty.call(props, k)) out[k] = props[k];
      }
      return out;
    }

    function send(name, props) {
      if (blocked) return;
      if (ready) {
        try { window.mixpanel.track(name, withScope(props || {})); } catch (e) {}
        return;
      }
      if (queue.length < 100) queue.push([name, props || {}]);
    }

    /* Events the Shopify custom pixel owns. It is the only source that survives
       the jump to checkout.shopify.com, so letting a second one report the same
       names on-domain produces a funnel where the first two steps are counted
       twice and the last three once. See the header for the measured damage. */
    var PIXEL_OWNED = {
      page_view: 1, view_item: 1, view_item_list: 1, view_cart: 1,
      add_to_cart: 1, remove_from_cart: 1, begin_checkout: 1,
      add_shipping_info: 1, add_payment_info: 1, purchase: 1, search: 1,
      // Google Ads conversion/remarketing names, for the same reason.
      conversion: 1, refund: 1, page_view_ecommerce: 1
    };

    /* ---------- GA4 shape → Mixpanel shape ----------
       The events arriving through the wrapper are written for GA4, and GA4's
       conventions are the wrong ones here in two specific ways. Both were
       measured on 2026-08-16 as "(not set)" in real reports:

       1. The product identity lives inside an `items` ARRAY. Mixpanel can break
          down a list-of-objects, but only through the nested-property picker —
          so the obvious report, "add to cart by product", split by `product_id`
          and returned (not set) for 100% of every theme-side event. A storefront
          event concerns exactly one product; the array is packaging, not data.
       2. GA4 calls it `item_id`, the Shopify pixel calls it `product_id`, and a
          funnel that crosses from the theme to checkout therefore has no single
          field naming the product. One name wins: `product_id`, because the
          pixel — the only source that survives the jump to checkout.shopify.com
          — cannot be renamed from here.

       Doing it in this one function rather than at ~25 call sites keeps GA4
       receiving exactly what it received before; only the Mixpanel copy is
       reshaped. Google's own junk parameters are dropped rather than forwarded:
       they describe the tag, not the shopper. */
    var DROP_PARAMS = {
      send_to: 1, event_id: 1, user_data: 1, developer_id: 1, ext_client_id: 1,
      ecomm_pagetype: 1, ecomm_prodid: 1, ecomm_totalvalue: 1,
      // A duplicate of item_list_name kept for a GA4 custom dimension that
      // Mixpanel has no use for; two names for one value is how a report ends
      // up disagreeing with itself.
      item_list_name_hl: 1
    };

    function normalize(params) {
      var out = {}, k;
      for (k in params) {
        if (Object.prototype.hasOwnProperty.call(params, k) && !DROP_PARAMS[k]) out[k] = params[k];
      }
      var items = out.items;
      if (items && items.length) {
        if (out.item_count == null) out.item_count = items.length;
        /* Only a ONE-item array describes one product. Lifting items[0] out of
           a longer list would label a whole grid impression with whichever
           product happened to be first in it — a plausible-looking value that
           is simply false. Multi-item events (a cart, a product list) keep the
           array, which is the shape Mixpanel's Cart Analysis reads anyway. */
        if (items.length === 1) {
          var it = items[0] || {};
          if (out.product_id == null && it.item_id != null) out.product_id = String(it.item_id);
          if (out.product_title == null && it.item_name) out.product_title = it.item_name;
          if (out.position == null && it.index != null) out.position = it.index;
          if (out.price == null && it.price != null) out.price = it.price;
          if (out.quantity == null && it.quantity != null) out.quantity = it.quantity;
          // The array now carries nothing the flat fields do not.
          delete out.items;
        }
      }
      if (out.product_id == null && out.item_id != null) out.product_id = String(out.item_id);
      if (out.product_id != null) out.product_id = String(out.product_id);
      delete out.item_id;
      return out;
    }

    /* Wrap gtag so our behavioural events are mirrored.

       layout/theme.liquid declares `function gtag(){dataLayer.push(arguments)}`
       in <head>, and this snippet renders at the end of <body>, so the original
       is always already there. Reassigning window.gtag also rebinds the bare
       `gtag` identifier those earlier scripts call, which is what makes a single
       wrapper catch every send site without editing any of them.

       This must never throw or swallow: gtag carries the shop's own conversion
       tracking, and Mixpanel is not allowed to be the reason a purchase goes
       unreported. */
    var nativeGtag = typeof window.gtag === 'function' ? window.gtag : null;
    window.gtag = function (kind, name, params) {
      try {
        if (kind === 'event' && typeof name === 'string' &&
            !(params && params.send_to) && !PIXEL_OWNED[name]) {
          send(name, normalize(params || {}));
        }
      } catch (e) {}
      if (nativeGtag) return nativeGtag.apply(this, arguments);
      // Defensive only — if load order ever changes, replicate what theme.liquid's
      // gtag does rather than dropping the hit on the floor.
      (window.dataLayer = window.dataLayer || []).push(arguments);
    };

    function group() {
      return (window.__hlGaParams && window.__hlGaParams.content_group) || 'other';
    }

    /* ---------- traffic source labelling ----------
       Mixpanel records utm_source and a raw referrer, but it has no channel
       grouping — nothing turns "ig" + "paid" into "Paid Social" the way GA4
       does, so every question about where buyers come from means re-deriving
       the rule by hand in each report. This computes it once, at init, and
       registers it as a super property, so EVERY event carries the label.

       Two rules that matter more than the classification itself:

       1. The first non-direct source of a session wins. Without that, a shopper
          who arrives from an Instagram ad and then clicks to a second page gets
          relabelled "Direct" on page two, and the ad loses credit for the
          purchase it paid for.
       2. Internal navigation returns null rather than "Direct" — moving around
          the shop is not a new visit.

       The 30-minute window is not arbitrary: it matches the Session Timeout
       configured on Mixpanel project 4053994, so a label here covers exactly
       one Mixpanel session. */
    var SRC_KEY = 'hl_src';
    /* @hl:classify:start */
    /* One classifier for the storefront and the checkout pixel. The pixel holds a
       byte-for-byte copy of this region (tests/pixel-sync.test.mjs enforces it).
       channel is GA4's Default Channel Group exactly (owner, 2026-10-16: "GA4
       gắn như thế nào thì Mixpanel gắn như thế"): step A derives source /
       medium / campaign as GA4 does, step B applies GA4's channel table.
       Anything we know beyond GA4 (srsltid, the Google app, AI feeds) never
       changes the channel. */
    /* @hl:srccat:start */
    /* GA4 source categories: Google's published list (819 sources), generated by
       tools/gen_source_categories.mjs from tools/ga4_source_categories.txt. Do not edit by hand. */
    var HL_SRC_CAT = {
      SEARCH: '360.cn|alice|aol|ar.search.yahoo.com|ask|at.search.yahoo.com|au.search.yahoo.com|auone|avg|babylon|baidu|biglobe|biglobe.co.jp|biglobe.ne.jp|bing|br.search.yahoo.com|ca.search.yahoo.com|centrum.cz|ch.search.yahoo.com|cl.search.yahoo.com|cn.bing.com|cnn|co.search.yahoo.com|comcast|conduit|daum|daum.net|de.search.yahoo.com|dk.search.yahoo.com|dogpile|dogpile.com|duckduckgo|ecosia.org|email.seznam.cz|eniro|es.search.yahoo.com|espanol.search.yahoo.com|exalead.com|excite.com|fi.search.yahoo.com|firmy.cz|fr.search.yahoo.com|globo|go.mail.ru|google|google-play|hk.search.yahoo.com|id.search.yahoo.com|in.search.yahoo.com|incredimail|it.search.yahoo.com|kvasir|lens.google.com|lite.qwant.com|lycos|m.baidu.com|m.naver.com|m.search.naver.com|m.sogou.com|mail.rambler.ru|mail.yandex.ru|malaysia.search.yahoo.com|msn|msn.com|mx.search.yahoo.com|najdi|naver|naver.com|news.google.com|nl.search.yahoo.com|no.search.yahoo.com|ntp.msn.com|nz.search.yahoo.com|onet|onet.pl|pe.search.yahoo.com|ph.search.yahoo.com|pl.search.yahoo.com|play.google.com|qwant|qwant.com|rakuten|rakuten.co.jp|rambler|rambler.ru|se.search.yahoo.com|search-results|search.aol.co.uk|search.aol.com|search.google.com|search.smt.docomo.ne.jp|search.ukr.net|secureurl.ukr.net|seznam|seznam.cz|sg.search.yahoo.com|so.com|sogou|sogou.com|sp-web.search.auone.jp|startsiden|startsiden.no|suche.aol.de|terra|th.search.yahoo.com|tr.search.yahoo.com|tut.by|tw.search.yahoo.com|uk.search.yahoo.com|ukr|us.search.yahoo.com|virgilio|vn.search.yahoo.com|wap.sogou.com|webmaster.yandex.ru|websearch.rakuten.co.jp|yahoo|yahoo.co.jp|yahoo.com|yandex|yandex.by|yandex.com|yandex.com.tr|yandex.fr|yandex.kz|yandex.ru|yandex.ua|yandex.uz|zen.yandex.ru',
      SOCIAL: '43things|43things.com|51.com|5ch.net|Hatena|ImageShack|academia.edu|activerain|activerain.com|activeworlds|activeworlds.com|addthis|addthis.com|airg.ca|allnurses.com|allrecipes.com|alumniclass|alumniclass.com|ameba.jp|ameblo.jp|americantowns|americantowns.com|amp.reddit.com|ancestry.com|anobii|anobii.com|answerbag|answerbag.com|answers.yahoo.com|aolanswers|aolanswers.com|apps.facebook.com|ar.pinterest.com|artstation.com|askubuntu|askubuntu.com|asmallworld.com|athlinks|athlinks.com|away.vk.com|awe.sm|b.hatena.ne.jp|baby-gaga|baby-gaga.com|babyblog.ru|badoo|badoo.com|bebo|bebo.com|beforeitsnews|beforeitsnews.com|bharatstudent|bharatstudent.com|biip.no|biswap.org|bit.ly|blackcareernetwork.com|blackplanet|blackplanet.com|blip.fm|blog.com|blog.feedspot.com|blog.goo.ne.jp|blog.naver.com|blog.yahoo.co.jp|blogg.no|bloggang.com|blogger|blogger.com|blogher|blogher.com|bloglines|bloglines.com|blogs.com|blogsome|blogsome.com|blogspot|blogspot.com|blogster|blogster.com|blurtit|blurtit.com|bookmarks.yahoo.co.jp|bookmarks.yahoo.com|br.pinterest.com|brightkite|brightkite.com|brizzly|brizzly.com|business.facebook.com|buzzfeed|buzzfeed.com|buzznet|buzznet.com|cafe.naver.com|cafemom|cafemom.com|camospace|camospace.com|canalblog.com|care.com|care2|care2.com|caringbridge.org|catster|catster.com|cbnt.io|cellufun|cellufun.com|centerblog.net|chat.zalo.me|chegg.com|chicagonow|chicagonow.com|chiebukuro.yahoo.co.jp|classmates|classmates.com|classquest|classquest.com|co.pinterest.com|cocolog-nifty|cocolog-nifty.com|copainsdavant.linternaute.com|couchsurfing.org|cozycot|cozycot.com|cross.tv|crunchyroll|crunchyroll.com|cyworld|cyworld.com|cz.pinterest.com|d.hatena.ne.jp|dailystrength.org|deluxe.com|deviantart|deviantart.com|dianping|dianping.com|digg|digg.com|diigo|diigo.com|discover.hubpages.com|disqus|disqus.com|dogster|dogster.com|dol2day|dol2day.com|doostang|doostang.com|dopplr|dopplr.com|douban|douban.com|draft.blogger.com|draugiem.lv|drugs-forum|drugs-forum.com|dzone|dzone.com|edublogs.org|elftown|elftown.com|epicurious.com|everforo.com|exblog.jp|extole|extole.com|facebook|facebook.com|faceparty|faceparty.com|fandom.com|fanpop|fanpop.com|fark|fark.com|fb|fb.me|fc2|fc2.com|feedspot|feministing|feministing.com|filmaffinity|filmaffinity.com|flickr|flickr.com|flipboard|flipboard.com|folkdirect|folkdirect.com|foodservice|foodservice.com|forums.androidcentral.com|forums.crackberry.com|forums.imore.com|forums.nexopia.com|forums.webosnation.com|forums.wpcentral.com|fotki|fotki.com|fotolog|fotolog.com|foursquare|foursquare.com|free.facebook.com|friendfeed|friendfeed.com|fruehstueckstreff.org|fubar|fubar.com|gaiaonline|gaiaonline.com|gamerdna|gamerdna.com|gather.com|geni.com|getpocket.com|glassboard|glassboard.com|glassdoor|glassdoor.com|godtube|godtube.com|goldenline.pl|goldstar|goldstar.com|goo.gl|gooblog|goodreads|goodreads.com|google+|googlegroups.com|googleplus|govloop|govloop.com|gowalla|gowalla.com|gree.jp|groups.google.com|gulli.com|gutefrage.net|habbo|habbo.com|hi5|hi5.com|hootsuite|hootsuite.com|houzz|houzz.com|hoverspot|hoverspot.com|hr.com|hu.pinterest.com|hubculture|hubculture.com|hubpages.com|hyves.net|hyves.nl|ibibo|ibibo.com|id.pinterest.com|identi.ca|ig|imageshack.com|imageshack.us|imvu|imvu.com|in.pinterest.com|insanejournal|insanejournal.com|instagram|instagram.com|instapaper|instapaper.com|internations.org|interpals.net|intherooms|intherooms.com|irc-galleria.net|is.gd|italki|italki.com|jammerdirect|jammerdirect.com|jappy.com|jappy.de|kaboodle.com|kakao|kakao.com|kakaocorp.com|kaneva|kaneva.com|kin.naver.com|l.facebook.com|l.instagram.com|l.messenger.com|last.fm|librarything|librarything.com|lifestream.aol.com|line|line.me|linkedin|linkedin.com|listal|listal.com|listography|listography.com|livedoor.com|livedoorblog|livejournal|livejournal.com|lm.facebook.com|lnkd.in|m.blog.naver.com|m.cafe.naver.com|m.facebook.com|m.kin.naver.com|m.vk.com|m.yelp.com|mbga.jp|medium.com|meetin.org|meetup|meetup.com|meinvz.net|meneame.net|menuism.com|messages.google.com|messages.yahoo.co.jp|messenger|messenger.com|mix.com|mixi.jp|mobile.facebook.com|mocospace|mocospace.com|mouthshut|mouthshut.com|movabletype|movabletype.com|mubi|mubi.com|my.opera.com|myanimelist.net|myheritage|myheritage.com|mylife|mylife.com|mymodernmet|mymodernmet.com|myspace|myspace.com|netvibes|netvibes.com|news.ycombinator.com|newsshowcase|nexopia|ngopost.org|niconico|nicovideo.jp|nightlifelink|nightlifelink.com|ning|ning.com|nl.pinterest.com|odnoklassniki.ru|odnoklassniki.ua|okwave.jp|old.reddit.com|oneworldgroup.org|onstartups|onstartups.com|opendiary|opendiary.com|oshiete.goo.ne.jp|out.reddit.com|over-blog.com|overblog.com|paper.li|partyflock.nl|photobucket|photobucket.com|pinboard|pinboard.in|pingsta|pingsta.com|pinterest|pinterest.at|pinterest.ca|pinterest.ch|pinterest.cl|pinterest.co.kr|pinterest.co.uk|pinterest.com|pinterest.com.au|pinterest.com.mx|pinterest.de|pinterest.es|pinterest.fr|pinterest.it|pinterest.jp|pinterest.nz|pinterest.ph|pinterest.pt|pinterest.ru|pinterest.se|pixiv.net|pl.pinterest.com|playahead.se|plurk|plurk.com|plus.google.com|plus.url.google.com|pocket.co|posterous|posterous.com|pro.homeadvisor.com|pulse.yahoo.com|qapacity|qapacity.com|quechup|quechup.com|quora|quora.com|qzone.qq.com|ravelry|ravelry.com|reddit|reddit.com|redux|redux.com|renren|renren.com|researchgate.net|reunion|reunion.com|reverbnation|reverbnation.com|rtl.de|ryze|ryze.com|salespider|salespider.com|scoop.it|screenrant|screenrant.com|scribd|scribd.com|scvngr|scvngr.com|secondlife|secondlife.com|serverfault|serverfault.com|shareit|sharethis|sharethis.com|shvoong.com|sites.google.com|skype|skyrock|skyrock.com|slashdot.org|slideshare.net|smartnews.com|snapchat|snapchat.com|social|sociallife.com.br|socialvibe|socialvibe.com|spaces.live.com|spoke|spoke.com|spruz|spruz.com|ssense.com|stackapps|stackapps.com|stackexchange|stackexchange.com|stackoverflow|stackoverflow.com|stardoll.com|stickam|stickam.com|studivz.net|suomi24.fi|superuser|superuser.com|sweeva|sweeva.com|t.co|t.me|tagged|tagged.com|taggedmail|taggedmail.com|talkbiznow|talkbiznow.com|taringa.net|techmeme|techmeme.com|tencent|tencent.com|tiktok|tiktok.com|tinyurl|tinyurl.com|toolbox|toolbox.com|touch.facebook.com|tr.pinterest.com|travellerspoint|travellerspoint.com|tripadvisor|tripadvisor.com|trombi|trombi.com|trustpilot|tudou|tudou.com|tuenti|tuenti.com|tumblr|tumblr.com|tweetdeck|tweetdeck.com|twitter|twitter.com|twoo.com|typepad|typepad.com|unblog.fr|urbanspoon.com|ushareit.com|ushi.cn|vampirefreaks|vampirefreaks.com|vampirerave|vampirerave.com|vg.no|video.ibm.com|vk.com|vkontakte.ru|wakoopa|wakoopa.com|wattpad|wattpad.com|web.facebook.com|web.skype.com|webshots|webshots.com|wechat|wechat.com|weebly|weebly.com|weibo|weibo.com|wer-weiss-was.de|weread|weread.com|whatsapp|whatsapp.com|wiki.answers.com|wikihow.com|wikitravel.org|woot.com|wordpress|wordpress.com|wordpress.org|xanga|xanga.com|xing|xing.com|yahoo-mbga.jp|yammer|yammer.com|yelp|yelp.co.uk|yelp.com|youroom.in|za.pinterest.com|zalo|zoo.gr|zooppa|zooppa.com',
      SHOPPING: 'Google Shopping|IGShopping|aax-us-east.amazon-adsystem.com|aax.amazon-adsystem.com|alibaba|alibaba.com|amazon|amazon.co.uk|amazon.com|apps.shopify.com|checkout.shopify.com|checkout.stripe.com|cr.shopping.naver.com|cr2.shopping.naver.com|ebay|ebay.co.uk|ebay.com|ebay.com.au|ebay.de|etsy|etsy.com|m.alibaba.com|m.shopping.naver.com|mercadolibre|mercadolibre.com|mercadolibre.com.ar|mercadolibre.com.mx|message.alibaba.com|msearch.shopping.naver.com|nl.shopping.net|no.shopping.net|offer.alibaba.com|one.walmart.com|order.shopping.yahoo.co.jp|partners.shopify.com|s3.amazonaws.com|se.shopping.net|shop.app|shopify|shopify.com|shopping.naver.com|shopping.yahoo.co.jp|shopping.yahoo.com|shopzilla|shopzilla.com|simplycodes.com|store.shopping.yahoo.co.jp|stripe|stripe.com|uk.shopping.net|walmart|walmart.com',
      VIDEO: 'blog.twitch.tv|crackle|crackle.com|curiositystream|curiositystream.com|d.tube|dailymotion|dailymotion.com|dashboard.twitch.tv|disneyplus|disneyplus.com|fast.wistia.net|help.hulu.com|help.netflix.com|hulu|hulu.com|id.twitch.tv|iq.com|iqiyi|iqiyi.com|jobs.netflix.com|justin.tv|m.twitch.tv|m.youtube.com|music.youtube.com|netflix|netflix.com|player.twitch.tv|player.vimeo.com|ted|ted.com|twitch|twitch.tv|utreon|utreon.com|veoh|veoh.com|viadeo.journaldunet.com|vimeo|vimeo.com|wistia|wistia.com|youku|youku.com|youtube|youtube.com'
    };
    /* @hl:srccat:end */
    var HL_OWN = Object.prototype.hasOwnProperty;

    /* ---- step A: source / medium / campaign, the way GA4 derives them ----
       Checked against GA4's sessionSource x sessionMedium x pageReferrer on the
       property (audit §5.2). null = not a new touch (our own host). */
    /* AI assistants GA4 gives medium ai-assistant: chatgpt.com, gemini.google.com
       (seen on the property) and Google's other named examples, Copilot,
       DeepSeek, Grok (audit A-6). Perplexity, Claude etc. are not on Google's
       list, so they stay referrals here; ai_source still names them. */
    var HL_AI_REF = /(^|\.)(chatgpt\.com|gemini\.google\.com|copilot\.microsoft\.com|deepseek\.com|grok\.com)$/;
    /* Search-engine referrers GA4 turns into "<engine> / organic". Only
       google.<tld> is google (news.google.com, mail.google.com are referrals);
       search.brave.com is a referral on the property. */
    var HL_SE = [[/^google\.[a-z.]+$/, 'google'], [/(^|\.)bing\.com$/, 'bing'], [/(^|\.)duckduckgo\.com$/, 'duckduckgo'],
      [/(^|\.)search\.yahoo\.[a-z.]+$/, 'yahoo'], [/(^|\.)ecosia\.org$/, 'ecosia.org'], [/(^|\.)yandex\.[a-z.]+$/, 'yandex'],
      [/(^|\.)baidu\.com$/, 'baidu']];
    /* Our shop, Shopify's checkout and payment returns: never a new touch.
       shopify.com itself is not here (GA4: shopify.com / referral). */
    var HL_HOME = /(^|\.)(thehouseland\.com|myshopify\.com|checkout\.shopify\.com|shop\.app|paypal\.com|stripe\.com|klarna\.com|afterpay\.com)$/;

    function hlSourceMedium(search, referrer) {
      var q;
      try { q = new URLSearchParams(search || ''); } catch (e) { q = new URLSearchParams(''); }
      var host = '', name = '', scheme = '';
      try {
        if (referrer) {
          var u = new URL(referrer);
          scheme = u.protocol;
          name = u.hostname.toLowerCase().replace(/^www\./, '');   // for matching
          host = u.host.toLowerCase().replace(/^www\./, '');       // the source: port kept
        }
      } catch (e) {}
      var app = scheme === 'android-app:';
      var home = !app && !!name && HL_HOME.test(name);
      function sm(s, m, c) { return { source: s, medium: m, campaign: c, content: q.get('utm_content') || null }; }

      if (q.get('gclid') || q.get('gbraid') || q.get('wbraid')) return sm('google', 'cpc', q.get('utm_campaign') || '(not set)');
      var utm = false;
      q.forEach(function (v, k) { if (/^utm_/i.test(k)) utm = true; });
      if (utm) {
        var s = q.get('utm_source') || (!app && !home && host) || '(not set)';
        var m = q.get('utm_medium') || (HL_AI_REF.test(s.toLowerCase()) ? 'ai-assistant' : '(not set)');
        return sm(s, m, q.get('utm_campaign') || '(not set)');
      }
      if (!name || app) return sm('(direct)', '(none)', null);
      if (home) return null;
      if (HL_AI_REF.test(name)) return sm(host, 'ai-assistant', '(ai-assistant)');
      for (var i = 0; i < HL_SE.length; i++) {
        if (HL_SE[i][0].test(name)) return sm(HL_SE[i][1], 'organic', null);
      }
      return sm(host === 'l.instagram.com' ? 'instagram.com' : host, 'referral', null);
    }

    /* ---- step B: channel = GA4 Default Channel Group, in GA4's order ----
       https://support.google.com/analytics/answer/9756891 (audit §5.3). Source
       categories come from HL_SRC_CAT, matched on the source of step A, exact,
       case-insensitive. */
    var HL_PAID = /^(.*cp.*|ppc|retargeting|paid.*)$/;
    var HL_SHOP_CAMPAIGN = /^(.*(([^a-df-z]|^)shop|shopping).*)$/;
    var HL_SOCIAL_MEDIUM = /^(social|social-network|social-media|sm|social network|social media)$/;
    var HL_DISPLAY_MEDIUM = /^(display|banner|expandable|interstitial|cpm)$/;
    var HL_EMAIL = /^(email|e-mail|e_mail|e mail)$/;
    var HL_CAT = null;   // '=' + lowercased source -> category, built on first use

    function hlCategory(source) {
      if (!HL_CAT) {
        HL_CAT = {};
        for (var c in HL_SRC_CAT) {
          if (!HL_OWN.call(HL_SRC_CAT, c)) continue;
          var list = HL_SRC_CAT[c].split('|');
          for (var i = 0; i < list.length; i++) HL_CAT['=' + list[i].toLowerCase()] = c;
        }
      }
      var k = '=' + String(source || '').toLowerCase();
      return HL_OWN.call(HL_CAT, k) ? HL_CAT[k] : null;
    }

    function hlChannel(source, medium, campaign) {
      var s = String(source || '').toLowerCase();
      var m = String(medium || '').toLowerCase();
      var c = String(campaign || '').toLowerCase();
      var cat = hlCategory(s);
      var paid = HL_PAID.test(m);
      var shop = cat === 'SHOPPING' || HL_SHOP_CAMPAIGN.test(c);
      if (s === '(direct)' && (m === '(none)' || m === '(not set)')) return 'Direct';
      if (c.indexOf('cross-network') >= 0) return 'Cross-network';
      if (paid && shop) return 'Paid Shopping';
      if (paid && cat === 'SEARCH') return 'Paid Search';
      if (paid && cat === 'SOCIAL') return 'Paid Social';
      if (paid && cat === 'VIDEO') return 'Paid Video';
      if (HL_DISPLAY_MEDIUM.test(m)) return 'Display';
      if (paid) return 'Paid Other';
      if (shop) return 'Organic Shopping';
      if (cat === 'SOCIAL' || HL_SOCIAL_MEDIUM.test(m)) return 'Organic Social';
      if (cat === 'VIDEO' || m.indexOf('video') >= 0) return 'Organic Video';
      if (cat === 'SEARCH' || m === 'organic') return 'Organic Search';
      if (m === 'ai-assistant') return 'AI Assistant';
      if (m === 'referral' || m === 'app' || m === 'link') return 'Referral';
      if (HL_EMAIL.test(s) || HL_EMAIL.test(m)) return 'Email';
      if (m === 'affiliate') return 'Affiliates';
      if (m === 'audio') return 'Audio';
      if (s === 'sms' || m === 'sms') return 'SMS';
      if (/push$/.test(m) || m.indexOf('mobile') >= 0 || m.indexOf('notification') >= 0 || s === 'firebase') return 'Mobile Push Notifications';
      return 'Unassigned';
    }

    /* { channel, source, medium, campaign, content }, or null when this page
       view is not a new touch (our own host). */
    function hlClassify(search, referrer) {
      var t = hlSourceMedium(search, referrer);
      if (!t) return null;
      t.channel = hlChannel(t.source, t.medium, t.campaign);
      return t;
    }

    /* A touch read back from hl_attr / hl_src: the channel is recomputed from
       its source / medium / campaign with the rules above, never trusted as
       stored. Cookies written before 2026-10-16 say AI Referral (medium "ai")
       or Campaign; an AI Referral from an A-6 assistant with no real medium is
       what GA4 calls <source> / ai-assistant. null = no touch stored. */
    function hlRestore(ch, s, m, c) {
      if (!ch) return null;
      if (ch === 'AI Referral' && /^(ai|referral|\(not set\))?$/.test(String(m || '').toLowerCase())) {
        m = HL_AI_REF.test(String(s || '').toLowerCase()) ? 'ai-assistant' : '(not set)';
      }
      return {
        channel: (ch === 'Direct' && !s && !m) ? 'Direct' : hlChannel(s, m, c),
        source: s == null ? null : s,
        medium: m == null ? null : m,
        campaign: c == null ? null : c
      };
    }

    /* ---- evidence: what we know beyond GA4 (audit C-14, C-15) ----
       Never changes the channel. Session properties, fixed at session start:
         ai_source     an AI assistant, from utm_source or the referrer, even
                       where GA4 says Unassigned / Referral (ChatGPT's feed);
         ai_surface    feed (utm_medium=feed or _gsid) | citation;
         click_id      the click-id parameter present (Google, Meta, TikTok,
                       Microsoft) — srsltid with no referrer is Google organic
                       that GA4 calls Direct;
         referrer_app  the android-app:// package GA4 calls Direct;
         ua_app        the in-app browser (Google app GSA, Facebook, Instagram…);
         landing_search / landing_referrer  the raw landing (255 chars, safe for
                       a Mixpanel string property), since
                       $current_url loses utm parameters. */
    var HL_AI_HOST = /(^|\.)(chatgpt\.com|openai\.com|perplexity\.ai|copilot\.microsoft\.com|gemini\.google\.com|claude\.ai|you\.com|phind\.com|poe\.com|grok\.com|deepseek\.com|mistral\.ai|felo\.ai|kagi\.com|meta\.ai)$/;
    var HL_AI_SOURCE = /^(chatgpt|chat\.openai\.com|openai|perplexity|copilot|gemini|claude|grok|deepseek|mistral|phind|poe|kagi|meta\.ai)$/;
    var HL_CLICK_IDS = ['gclid', 'gbraid', 'wbraid', 'fbclid', 'srsltid', 'ttclid', 'msclkid'];
    var HL_UA_APPS = [[/\bGSA\//, 'GSA'], [/Instagram/, 'Instagram'], [/FBAN|FBAV|FB_IAB|FBIOS/, 'FB_IAB'],
      [/musical_ly|BytedanceWebview|TikTok/i, 'TikTok'], [/Pinterest/, 'Pinterest'], [/Snapchat/, 'Snapchat'],
      [/LinkedInApp/, 'LinkedIn'], [/\bLine\//, 'Line']];

    function hlEvidence(search, referrer, ua) {
      var q;
      try { q = new URLSearchParams(search || ''); } catch (e) { q = new URLSearchParams(''); }
      var name = '', scheme = '';
      try {
        if (referrer) {
          var u = new URL(referrer);
          scheme = u.protocol;
          name = u.hostname.toLowerCase().replace(/^www\./, '');
        }
      } catch (e) {}
      var src = (q.get('utm_source') || '').toLowerCase();
      var ai = (src && (HL_AI_SOURCE.test(src) || HL_AI_HOST.test(src))) ? src
             : (scheme !== 'android-app:' && name && HL_AI_HOST.test(name)) ? name : null;
      var click = null;
      for (var i = 0; i < HL_CLICK_IDS.length && !click; i++) {
        if (q.get(HL_CLICK_IDS[i]) !== null) click = HL_CLICK_IDS[i];
      }
      var app = null;
      for (var j = 0; j < HL_UA_APPS.length && !app; j++) {
        if (HL_UA_APPS[j][0].test(ua || '')) app = HL_UA_APPS[j][1];
      }
      return {
        ai_source: ai,
        ai_surface: ai ? ((/^feed$/i.test(q.get('utm_medium') || '') || q.get('_gsid') !== null) ? 'feed' : 'citation') : null,
        click_id: click,
        referrer_app: (scheme === 'android-app:' && name) ? name : null,
        ua_app: app,
        landing_search: search ? String(search).slice(0, 255) : null,
        landing_referrer: referrer ? String(referrer).slice(0, 255) : null
      };
    }
    /* @hl:classify:end */

    /* @hl:touch:start */
    var HL_SESSION_TTL = 30 * 60 * 1000;            // Mixpanel project session timeout
    var HL_ATTR_TTL = 30 * 24 * 60 * 60 * 1000;     // purchase attribution window
    var HL_DIRECT = { channel: 'Direct', source: '(direct)', medium: '(none)', campaign: null, content: null };
    var HL_OWN_KEY = Object.prototype.hasOwnProperty;

    /* Sliding 30-minute session: every page refreshes the timestamp, so a
       shopper who keeps browsing keeps the channel they arrived with.

       S-1 (GA4): the session's touch is fixed when the session starts; a new
       touch mid-session (a chatgpt reload, an Instagram link) does not change
       it. Only a new session takes a new touch.
       S-2 (GA4: "sessions initiated by direct entrance are attributed to the
       UTM values for that user"): a session that starts Direct takes the last
       non-direct touch in hl_attr (ch/s/m/c/ct, the same 30-day window),
       flagged direct_entry so true direct entries stay countable.
       Stored touches (hl_src, hl_attr) get their channel recomputed
       (hlRestore), so a pre-rewrite name never comes back. GA4's own
       lookback may be longer (up to 90 days); past 30 days this says Direct. */
    function hlSessionTouch(stored, fresh, now, prev, evidence) {
      var live = (stored && stored.v && typeof stored.t === 'number' && (now - stored.t) < HL_SESSION_TTL) ? stored.v : null;
      var lr = live ? hlRestore(live.channel, live.source, live.medium, live.campaign) : null;
      if (lr) {
        var kept = {};
        for (var f in live) {
          if (HL_OWN_KEY.call(live, f)) kept[f] = live[f];
        }
        kept.channel = lr.channel;
        kept.medium = lr.medium;
        return { touch: kept, store: { v: kept, t: now } };
      }
      var base = fresh || HL_DIRECT;
      var pr = (prev && typeof prev.t === 'number' && (now - prev.t) < HL_ATTR_TTL) ? hlRestore(prev.ch, prev.s, prev.m, prev.c) : null;
      var p = (pr && pr.channel !== 'Direct') ? pr : null;
      var touch = (base.channel === 'Direct' && p)
        ? { channel: p.channel, source: p.source, medium: p.medium, campaign: p.campaign, content: prev.ct || null, direct_entry: true }
        : { channel: base.channel, source: base.source, medium: base.medium, campaign: base.campaign || null, content: base.content || null };
      // This landing's evidence, whichever touch the session took (a copy:
      // HL_DIRECT is shared).
      for (var k in (evidence || {})) {
        if (HL_OWN_KEY.call(evidence, k)) touch[k] = evidence[k];
      }
      return { touch: touch, store: { v: touch, t: now } };
    }

    /* ch/s/m/c/ct/t: last non-direct touch within 30 days (purchase credit).
       credit is the touch THIS page brought (null: none); omitted, it is the
       session touch. A Direct visit, or a session that inherited its touch
       (direct_entry), never overwrites a live non-direct touch, and t stays at
       the moment of that touch.
       sc/ss/sm/sca: THIS session's touch (the journey channel), rewritten on
       every page so the checkout pixel reports the same `channel` the
       storefront events carry. did survives an expired touch; i is sticky.
       dev: Mixpanel's $device_id, sticky like did. The pixel needs it because
       Mixpanel drops a $user_id equal to the $device_id, so a device that
       identified as itself still lives on "$device:<dev>". */
    function hlNextAttr(prev, touch, did, isTeam, now, dev, credit) {
      var p = (prev && typeof prev.t === 'number' && (now - prev.t) < HL_ATTR_TTL) ? prev : null;
      var pr = p ? hlRestore(p.ch, p.s, p.m, p.c) : null;   // never trust a stored name
      var cr = credit === undefined ? touch : credit;
      if (cr && cr.direct_entry) cr = null;
      var keep = pr && pr.channel !== 'Direct' && (!cr || cr.channel === 'Direct');
      var c = cr || HL_DIRECT;
      var next = keep
        ? { ch: pr.channel, s: p.s, m: pr.medium, c: p.c, ct: p.ct, t: p.t }
        : { ch: c.channel, s: c.source, m: c.medium, c: c.campaign || null, ct: c.content || null, t: now };
      var t = touch || HL_DIRECT;
      next.did = did || (prev && prev.did) || null;
      next.i = (isTeam || (prev && prev.i === 1)) ? 1 : 0;   // once team, always team
      next.sc = t.channel;
      next.ss = t.source;
      next.sm = t.medium;
      next.sca = t.campaign || null;
      next.dev = dev || (prev && prev.dev) || null;
      return next;
    }
    /* @hl:touch:end */

    /* Once per page: the session touch, and the touch this page itself brought
       (TRAFFIC_CREDIT, for attribution_*; null when it brought none). Our own
       internal UTMs (utm_medium=internal, the blog cards) never earn the
       30-day credit, as before; as a session's opening touch they still set
       its channel (GA4: Unassigned). */
    var TRAFFIC = null;
    var TRAFFIC_CREDIT = null;
    function trafficProps() {
      if (TRAFFIC) return TRAFFIC;
      var stored = null;
      try { stored = JSON.parse(localStorage.getItem(SRC_KEY) || 'null'); } catch (e) {}
      var fresh = hlClassify(LANDING_SEARCH, LANDING_REFERRER);
      var ua = '';
      try { ua = navigator.userAgent || ''; } catch (e) {}
      var r = hlSessionTouch(stored, fresh, Date.now(), readAttr(), hlEvidence(LANDING_SEARCH, LANDING_REFERRER, ua));
      try { localStorage.setItem(SRC_KEY, JSON.stringify(r.store)); } catch (e) {}
      TRAFFIC_CREDIT = (fresh && fresh.channel !== 'Direct' && String(fresh.medium).toLowerCase() !== 'internal') ? fresh : null;
      TRAFFIC = r.touch;
      return TRAFFIC;
    }

    /* ---------- hand the label to the checkout pixel ----------
       The Shopify custom pixel runs in a sandboxed frame on another origin, so
       it cannot read the localStorage above — and on a checkout page there is
       no utm parameter and the referrer is our own domain, so everything it can
       see says "Direct". Left alone, every purchase in Mixpanel is Direct and
       no ad can ever be credited with one.

       A cookie is the one channel both sides share: the pixel reads it with
       browser.cookie.get(), which the Web Pixels API proxies to the top frame.
       Written whenever the storefront snippet runs.

       30 days rather than the 30-minute session window: this is the value a
       purchase is attributed with, and a shopper who returns to buy the next
       day should still credit the ad that found them. */
    var ATTR_COOKIE = 'hl_attr';
    function readAttr() {
      var m = document.cookie.match(/(?:^|;\s*)hl_attr=([^;]+)/);
      if (!m) return null;
      try { return JSON.parse(decodeURIComponent(m[1])); } catch (e) { return null; }
    }
    /* Returns the value written (or computed, if the cookie write failed), so
       the boot can register the 30-day attribution as super properties.
       deviceId: Mixpanel's $device_id, or null/undefined to keep the cookie's. */
    function publishAttr(traffic, distinctId, isTeam, deviceId) {
      var v = null;
      try {
        v = hlNextAttr(readAttr(), traffic, distinctId, isTeam, Date.now(), deviceId, TRAFFIC_CREDIT);
        document.cookie = ATTR_COOKIE + '=' + encodeURIComponent(JSON.stringify(v)) +
                          ';path=/;max-age=' + (30 * 24 * 60 * 60) + ';SameSite=Lax';
      } catch (e) {}
      return v;
    }

    /* @hl:adopt:start */
    /* snippets/hl-identity-seed.liquid wrote hl_attr.dev at parse time, before
       this file and long before the SDK. The SDK mints its own $device_id only
       when its store (localStorage mp_<token>_mixpanel, plain JSON) has no
       distinct_id, so writing "$device:<dev>" there before init makes it adopt
       the seeded device: one id on both sides, no second user. An identity the
       SDK already holds is never touched (the seed copied it from there). */
    function hlAdoptDevice(attr, store, key) {
      try {
        if (!attr || !attr.dev) return false;
        var cur = null;
        try { cur = JSON.parse(store.getItem(key) || 'null'); } catch (e) { cur = null; }
        if (cur && typeof cur === 'object' && cur.distinct_id) return false;
        if (!cur || typeof cur !== 'object' || cur instanceof Array) cur = {};
        cur.distinct_id = '$device:' + attr.dev;
        cur.$device_id = String(attr.dev);
        store.setItem(key, JSON.stringify(cur));
        return true;
      } catch (e) { return false; }
    }
    /* @hl:adopt:end */

    /* ---------- gate 1: the team opt-out ----------
       Nothing is sent to Mixpanel from this browser. The hl_attr cookie still
       gets the sticky team flag (i = 1, other keys kept), so the checkout pixel
       and GA4 label this device internal too. Cookie only; never throws. */
    if (ls('hl_internal') === '1') {
      blocked = true;
      try {
        var optOut = readAttr();
        if (!optOut || typeof optOut !== 'object' || optOut instanceof Array) optOut = {};
        optOut.i = 1;
        document.cookie = ATTR_COOKIE + '=' + encodeURIComponent(JSON.stringify(optOut)) +
                          ';path=/;max-age=' + (30 * 24 * 60 * 60) + ';SameSite=Lax';
      } catch (e) {}
      return;
    }

    /* Our own browser automation, told apart from a shopper.

       Measured 2026-08-16: one "visitor" produced 404 events in two days, from
       Hanoi, with no _shopify_y cookie and no Shopify client id — the CDP /
       Playwright browsers this repo drives for screenshots, audits and theme
       checks. It was the third-busiest city in the report and the single
       heaviest user in the project, and nothing distinguished it from a
       customer.

       navigator.webdriver is set by every automation protocol (CDP, WebDriver,
       Playwright) and by nothing else; the UA test catches a headless build
       launched without the flag. Search-engine crawlers do not reach here —
       they do not execute this far — so this is not a robots filter, it is a
       filter for us.

       Automation is collected, not dropped: it arrives labelled
       is_automated=true, filterable with one clause. */
    function isAutomated() {
      try {
        if (navigator.webdriver === true) return true;
        return /HeadlessChrome|Puppeteer|Playwright|PhantomJS/i.test(navigator.userAgent || '');
      } catch (e) { return false; }
    }
    var IS_AUTOMATED = isAutomated();
    /* Crawlers that DO run JavaScript (Googlebot and Bingbot render pages, as
       do the AI fetchers and link-preview bots). They get no replay; their
       events still flow and are filtered downstream as before. */
    var IS_CRAWLER = (function () {
      try {
        return /bot\b|bot\/|crawl|spider|slurp|bingpreview|mediapartners|facebookexternalhit|embedly|lighthouse|pagespeed|gtmetrix|chrome-lighthouse|headless|preview/i
          .test(navigator.userAgent || '');
      } catch (e) { return false; }
    })();
    /* @hl:team:start */
    /* The team works from Vietnam. Shopify has already geolocated the visitor
       (Customer Privacy API getRegion, ISO 3166-2 such as "VNHN"); an empty or
       missing answer is not treated as team. Team traffic is still collected,
       stamped internal=true on every event and is_internal on the profile, and
       gets no Session Replay. The worker labels VN-IP devices as a backstop. */
    function hlIsTeamRegion(region) {
      return typeof region === 'string' && /^VN/.test(region);
    }
    /* @hl:team:end */

    /* Shopify's own consent and region, loaded once. consent-tracking-api is
       already requested on every page by hl-oaiq, so this adds no request.

       cb runs once, at the first answer or at the 2.5s fallback, whichever is
       first. Measured on the preview: getRegion() can become available 1.4-2.0s
       after load, so the fallback sometimes wins and boots with no region. When
       the real answer then arrives, lateCb gets it (once); an answer that came
       first never reaches lateCb. No extra request and no extra wait. */
    function withPrivacy(cb, lateCb) {
      var done = false;
      var answered = false;
      function finish() { if (!done) { done = true; cb(window.Shopify && window.Shopify.customerPrivacy); } }
      function answer() {
        if (answered) return;
        answered = true;
        if (!done) return finish();
        try { if (lateCb) lateCb(window.Shopify && window.Shopify.customerPrivacy); } catch (e) {}
      }
      try {
        if (window.Shopify && window.Shopify.customerPrivacy) return finish();
        if (window.Shopify && window.Shopify.loadFeatures) {
          window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], answer);
          setTimeout(finish, 2500);   // no later than the old /geo timeout
          return;
        }
      } catch (e) {}
      finish();
    }

    /* D1-A (owner decision 2026-09-15, confirmed 2026-10-15): analytics runs
       regardless of the consent banner. Kept as one function so a later change
       of policy is a one-line edit here. */
    function consentDecision(cp, cb) { cb(); }

    var TEAM_REGION = false;
    var SHOP_REGION = null;
    var IS_INTERNAL = false;
    var BOOTED = false;       // boot() has run (so the late region path may act)
    var REPLAY_ON = false;    // start_session_recording() has been called

    /* A device hl_attr has already marked as team (i = 1, sticky) stays
       internal on a later visit, e.g. a team phone on a US VPN. */
    function stickyTeam() {
      var a = readAttr();
      return !!(a && a.i === 1);
    }

    /* ---------- start ---------- */
    function boot() {
      BOOTED = true;
      IS_INTERNAL = TEAM_REGION || stickyTeam();
      /* Mixpanel's official loader stub, verbatim.

         A bare <script src="…mixpanel-2-latest.min.js"> does NOT work: measured
         on this store, the file fetched 200 with 104KB and window.mixpanel was
         still undefined afterwards. The library is built to find the stub's
         queue (`mixpanel._i`) already in place and replace it — without the stub
         it defines nothing.

         The stub injects the CDN script itself, which is exactly why it is
         called HERE and not at parse time: no request reaches Mixpanel until the
         hl_internal opt-out has been checked and Shopify's region is known (or
         its 2.5s fallback fired). Everything after this line is queued by the
         stub and replayed when the real library lands, so there is no onload to
         wait for. */
      // Before the SDK can load: it must find the seeded device in its store.
      try { hlAdoptDevice(readAttr(), window.localStorage, 'mp_' + TOKEN + '_mixpanel'); } catch (e) {}
      (function (f, b) {
        if (!b.__SV) {
          var e, g, i, h;
          window.mixpanel = b; b._i = [];
          b.init = function (e, f, c) {
            function g(a, d) { var b = d.split('.'); 2 == b.length && (a = a[b[0]], d = b[1]); a[d] = function () { a.push([d].concat(Array.prototype.slice.call(arguments, 0))) } }
            var a = b; 'undefined' !== typeof c ? a = b[c] = [] : c = 'mixpanel'; a.people = a.people || [];
            a.toString = function (a) { var d = 'mixpanel'; 'mixpanel' !== c && (d += '.' + c); a || (d += ' (stub)'); return d };
            a.people.toString = function () { return a.toString(1) + '.people (stub)' };
            i = 'disable time_event track track_pageview track_links track_forms track_with_groups add_group set_group remove_group register register_once alias unregister identify name_tag set_config reset opt_in_tracking opt_out_tracking has_opted_in_tracking has_opted_out_tracking clear_opt_in_out_tracking start_batch_senders people.set people.set_once people.unset people.increment people.append people.union people.track_charge people.clear_charges people.delete_user people.remove'.split(' ');
            for (h = 0; h < i.length; h++) g(a, i[h]);
            var j = 'set set_once union unset remove delete'.split(' ');
            a.get_group = function () { function b(c) { d[c] = function () { call2_args = arguments; call2 = [c].concat(Array.prototype.slice.call(call2_args, 0)); a.push([e, call2]) } } for (var d = {}, e = ['get_group'].concat(Array.prototype.slice.call(arguments, 0)), c = 0; c < j.length; c++)b(j[c]); return d };
            b._i.push([e, f, c])
          };
          b.__SV = 1.2;
          e = f.createElement('script'); e.type = 'text/javascript'; e.async = !0;
          e.src = 'https://cdn.mxpnl.com/libs/mixpanel-2-latest.min.js';
          g = f.getElementsByTagName('script')[0]; g.parentNode.insertBefore(e, g)
        }
      })(document, window.mixpanel || []);

      (function () {
        // Declared before init() because init's `loaded` callback closes over
        // both: it re-reads the cookie if it arrived late, and it hands the
        // resolved identity to the checkout pixel.
        var shopifyY = (document.cookie.match(/(?:^|;\s*)_shopify_y=([^;]+)/) || [])[1] || null;
        var traffic = null;
        try {
          window.mixpanel.init(TOKEN, {
            // We send our own, with content_group attached — Mixpanel's built-in
            // pageview has no idea this is a product page vs a blog post.
            track_pageview: false,
            // Our own page_view / dead_click / rage_click already exist; autocapture would
            // duplicate them as $mp_web_page_view / $mp_dead_click / $mp_rage_click.
            autocapture: false,
            persistence: 'localStorage',
            batch_requests: true,
            ignore_dnt: false,
            api_host: 'https://api-js.mixpanel.com',

            /* ---- Session Replay ----
               Off by default in the SDK (record_sessions_percent: 0), which is
               why no replay existed until this was added.

               100% because the shop takes ~90 visitors a day. Sampling exists
               for sites with millions of sessions; here it would just mean the
               one session worth watching is the one that was not recorded.
               Replays are kept 30 days by Mixpanel.

               The two masking defaults are deliberately split, not blanket-
               loosened:

                 text   unmasked. The SDK masks ALL text by default, which on a
                        storefront produces a replay of grey blocks — you cannot
                        see which product, price or variant the shopper looked
                        at, and that is the entire reason to watch it. Every
                        page this records is public catalogue content.
                        Exception below for anything customer-specific.
                 inputs LEFT MASKED (the default). Never loosen this: the
                        newsletter field, and any form a future app injects,
                        would otherwise be recorded keystroke by keystroke.
                        Password/email/tel inputs stay masked regardless.

               Account pages are the one place a logged-in shopper's own name
               and address render as page text, so those are masked explicitly.
               Checkout is not covered at all — it is Shopify's domain and the
               SDK never loads there.

               record_heatmap_data gives the replay UI its click / rage-click /
               dead-click layer. hl-ux-tracking.liquid measures rage and dead
               clicks as events already; this is the same behaviour rendered on
               top of the recording, which is where it is actually diagnosable.

               record_min_ms is deliberately NOT set. It defaults to 0, and any
               value above it would throw away exactly the recordings this shop
               needs most — the visitor who landed and left. */
            /* 0 here, started by hand from startReplay() below once the visitor
               proves to be a person (a trusted tap, click, key, wheel or mouse
               movement). Measured 13/10: of 2,182 raw blog sessions only 1,271
               were people; the rest were datacenter, dwell and footer bots that
               never touch the page, and every one of them was a replay. Anyone
               who adds to cart has clicked first, so no buying session is lost. */
            record_sessions_percent: 0,
            record_mask_all_text: false,
            record_mask_all_inputs: true,
            record_mask_text_selector: '.customer, .account, [class*="address"], .hl-bizbar',
            // Default blocks "img, video" — but on a home-decor shop the images
            // ARE the thing being evaluated, and they are public CDN URLs.
            // Video and iframes stay blocked (third-party, heavy, no value).
            record_block_selector: 'video, iframe',
            record_heatmap_data: true,

            /* The library is loaded asynchronously by the stub above, so
               everything before this point runs against a queue. get_distinct_id
               is not one of the queued methods — it has to return a value, so it
               exists only once the real library has landed. This callback is the
               only correct place to read it, and reading it is what lets the
               checkout pixel share this device's identity (see publishAttr). */
            loaded: function (mp) {
              try {
                var did = mp.get_distinct_id && mp.get_distinct_id();
                var dev = mp.get_property && mp.get_property('$device_id');
                // The cookie may have arrived after boot: Shopify writes
                // _shopify_y on the first response of a consented visit, which
                // can land after this snippet has already run.
                var late = (document.cookie.match(/(?:^|;\s*)_shopify_y=([^;]+)/) || [])[1] || null;
                if (late && !shopifyY) {
                  shopifyY = late;
                  try { mp.identify(late); } catch (e) {}
                  mp.register({ shopify_client_id: late });
                  did = mp.get_distinct_id && mp.get_distinct_id();
                }
                /* Shopify stopped writing _shopify_y around 26/09/2026: the
                   storefront now sets only the HttpOnly _shopify_essential /
                   _analytics / _marketing, which JS cannot read. With no
                   identify(), the SDK holds every people.set() for an anonymous
                   "$device:" id and never creates a profile — identified
                   visitors fell from 60-180 a day to 1-7. Identify with the
                   device's own id instead. Only while still anonymous, so an id
                   an earlier visit already set (a _shopify_y one) is kept. */
                if (!shopifyY) {
                  if (dev && typeof did === 'string' && did.indexOf('$device:') === 0) {
                    try { mp.identify(String(dev)); } catch (e) {}
                    did = mp.get_distinct_id && mp.get_distinct_id();
                  }
                }
                // trafficProps() is idempotent — it returns the label already
                // stored for this session — so calling it here cannot invent a
                // second answer if the callback somehow beat the assignment.
                publishAttr(traffic || trafficProps(), did, IS_INTERNAL, dev ? String(dev) : null);
              } catch (e) {}
            }
          });

          /* ---------- identity ----------
             `_shopify_y` is Shopify's visitor token and is exactly the value the
             checkout pixel sees as event.clientId. Using it as the distinct_id
             is what makes browsing and buying one person — see the header for
             the 3-users-vs-5-users measurement that forced this.

             Guarded because the cookie is absent on a first paint with cookies
             blocked; in that case the SDK keeps its own id and this visit simply
             does not join to checkout, which is strictly better than identifying
             everyone as "null".

             The cookie is read above, before init(); the direction of the join
             has also changed since this was written. It is no longer "both
             sides key on _shopify_y" — the pixel now prefers Mixpanel's own
             distinct_id, published in the hl_attr cookie, because a third of
             pixel events arrive with clientId empty and Shopify is retiring the
             cookie outright. This identify() still runs where the cookie exists,
             so the two ids remain the same value on most devices and nothing
             about the existing join changes. */
          if (shopifyY) {
            try { window.mixpanel.identify(shopifyY); } catch (e) {}
          }

          /* Super properties ride on every event, so a funnel can be split by
             page type, channel or internal-vs-customer without each call site
             remembering to send them. */
          traffic = trafficProps();
          var attrNow = publishAttr(traffic, shopifyY, IS_INTERNAL) || {};
          var superProps = {
            content_group: group(),
            shop: 'houseland',
            template: DATA.template,
            shopify_client_id: shopifyY || '(none)',
            /* Nulls are spelled out. A null property is indistinguishable from
               a missing one in a breakdown — both render "(not set)" — so a
               visit whose region never resolved and a visit the code forgot to
               label look identical in the report. '(unknown)' says Shopify did
               not answer. */
            /* Two questions, two sets of fields, same meaning on the storefront
               and in the checkout pixel:
                 channel, traffic_source, traffic_medium, campaign
                     this SESSION's touch (the journey);
                 attribution_channel / _source / _medium / _campaign
                     the last non-direct touch within 30 days (who gets the
                     purchase credit). */
            channel: traffic.channel || '(none)',
            traffic_source: traffic.source || '(none)',
            traffic_medium: traffic.medium || '(none)',
            // S-2: this session started Direct and took the user's last
            // non-direct touch (true direct entries stay countable).
            session_direct_entry: !!traffic.direct_entry,
            // Evidence beyond GA4 (hlEvidence); never changes channel.
            ai_source: traffic.ai_source || '(none)',
            ai_surface: traffic.ai_surface || '(none)',
            click_id: traffic.click_id || '(none)',
            referrer_app: traffic.referrer_app || '(none)',
            ua_app: traffic.ua_app || '(none)',
            landing_search: traffic.landing_search || '(none)',
            landing_referrer: traffic.landing_referrer || '(none)',
            attribution_channel: attrNow.ch || traffic.channel || '(none)',
            attribution_source: attrNow.s || traffic.source || '(none)',
            attribution_medium: attrNow.m || traffic.medium || '(none)',
            attribution_campaign: (attrNow.ch ? attrNow.c : traffic.campaign) || '(none)',
            shop_region: SHOP_REGION || '(unknown)',
            // The one property every report should filter on. See the header.
            // True for Vietnam, as reported by Shopify's getRegion().
            internal: IS_INTERNAL,
            is_automated: IS_AUTOMATED,
            logged_in: DATA.logged_in,

            /* ---- the page, on every event ----
               These were on page_view alone. Every other event — 100% of
               scroll_depth, section_view, faq_open, web_vital, js_error, all of
               it — arrived with no page at all, so "where did this happen"
               could not be asked of anything except a page view, and the
               obvious breakdown returned (not set) for the whole column.
               Re-registered on each page load, which is what keeps them
               current: super properties live in localStorage and would
               otherwise describe the page before this one. */
            page_path: location.pathname,
            page_title: document.title,
            page_type: DATA.template,
            // Prices ride on a dozen events and none of them said in what.
            // One store, one currency today — but a number with no unit is
            // not a fact, and the day a second currency opens this is the
            // field that stops every revenue figure being wrong in silence.
            currency: SHOP_CURRENCY,
            device_type: (window.matchMedia && window.matchMedia('(max-width: 749px)').matches)
              ? 'mobile' : 'desktop'
          };

          /* Page-scoped identity, rewritten on EVERY page load.

             Two failure modes, and the fix has to avoid both.

             Stale: Mixpanel keeps super properties until they are overwritten,
             so a product id registered on a product page would follow the
             shopper onto the home page and label every event there with the
             last thing they looked at. That is worse than (not set) — it is
             (not true), and nothing in the report would reveal it.

             Absent: unregistering instead is honest but it is exactly what puts
             "(not set)" in a breakdown, and a funnel step filtered on a
             property drops every event that lacks it, so absence quietly
             changes conversion rates as well as labels.

             So a page that has no product says so, in words: '(none)'. Same
             convention Mixpanel's own traffic fields use ((direct), (none)),
             and it reads correctly in a chart legend — "home page events" — in
             a way that "(not set)" never does. */
          var scoped = {
            product_id: DATA.product_id,
            product_handle: DATA.product_handle,
            product_title: DATA.product_title,
            product_type: DATA.product_type,
            collection_handle: DATA.collection_handle,
            collection_title: DATA.collection_title,
            article_handle: DATA.article_handle,
            blog_handle: DATA.blog_handle
          };
          Object.keys(scoped).forEach(function (k) {
            var v = scoped[k];
            superProps[k] = (v === null || v === '') ? NONE : String(v);
          });
          /* Retired super properties (the old /geo gate). Mixpanel keeps them in
             localStorage, so returning browsers kept sending them until removed. */
          try {
            window.mixpanel.unregister('geo_country');
            window.mixpanel.unregister('geo_source');
            window.mixpanel.unregister('track_override');
          } catch (e) {}
          window.mixpanel.register(superProps);

          /* First touch, as a super property and not only on the profile.

             Profile properties are the natural home for "where did this person
             originally come from", but a breakdown by a profile property
             returns (not set) for everyone who has no profile — which on a
             storefront is most of the traffic, since a profile is only created
             once something identifies them. Registering the same values as
             super properties makes first-touch answerable on the events
             themselves.

             register_once, so the first visit's answer survives every later
             one. That is the whole point of a first-touch field, and a plain
             register() would overwrite it with the most recent visit — the bug
             this pair of calls exists to avoid. */
          try {
            window.mixpanel.register_once({
              first_channel: traffic.channel || NONE,
              first_source: traffic.source || NONE,
              first_medium: traffic.medium || NONE,
              first_campaign: traffic.campaign || NONE,
              first_landing_path: location.pathname,
              first_referrer: LANDING_REFERRER || '(direct)',
              first_seen_at: new Date().toISOString()
            });
          } catch (e) {}

          /* Returning versus first-time, counted here rather than inferred.
             Mixpanel can derive "new user" from $created, but only for people
             who have a profile; this is a plain counter in the same storage the
             SDK already uses, so it answers for anonymous visitors too. */
          try {
            var visits = parseInt(localStorage.getItem('hl_visits') || '0', 10) || 0;
            var lastAt = parseInt(localStorage.getItem('hl_last_visit') || '0', 10) || 0;
            // A visit, not a page load: same 30-minute window as the project's
            // Session Timeout, so this counter and Mixpanel's sessions agree.
            if (!lastAt || (Date.now() - lastAt) > HL_SESSION_TTL) visits += 1;
            localStorage.setItem('hl_visits', String(visits));
            localStorage.setItem('hl_last_visit', String(Date.now()));
            window.mixpanel.register({
              session_number: visits,
              visitor_type: visits > 1 ? 'returning' : 'new'
            });
          } catch (e) {}

          /* Campaign fields must be REMOVED when this visit has none, not just
             left unset. Super properties live in localStorage and persist
             forever, so simply skipping the register call keeps the last
             campaign attached to every future event — caught in testing: a
             direct visit was still reporting campaign "aug_lamps" from an
             Instagram click in an earlier session. That silently credits a
             finished campaign with months of unrelated traffic.

             Written as '(none)' rather than unregistered, for the reason given
             under the scoped properties below: an absent property and a
             deliberately empty one both print "(not set)", and only one of them
             is a bug. */
          window.mixpanel.register({
            campaign: traffic.campaign || '(none)',
            campaign_content: traffic.content || '(none)'
          });

          /* ---------- the profile ----------
             Events answer "what happened"; the profile answers "who is this and
             where did they first come from" — which is the only way to build a
             cohort like "everyone Instagram brought in August who has never
             bought". None of it existed before: profiles were written for
             logged-in customers only, and this shop's visitors are almost never
             logged in.

             set_once for anything first-touch (it must survive every later
             visit), set for last-touch and for the fields that legitimately
             change. Mixpanel fills $city / $region / $country_code itself from
             the request IP. */
          try {
            window.mixpanel.people.set_once({
              $created: new Date().toISOString(),
              first_channel: traffic.channel,
              first_source: traffic.source,
              first_medium: traffic.medium,
              first_campaign: traffic.campaign || '(none)',
              first_landing_path: location.pathname,
              first_referrer: LANDING_REFERRER || '(direct)'
            });
            window.mixpanel.people.set({
              last_channel: traffic.channel,
              last_source: traffic.source,
              last_seen_at: new Date().toISOString(),
              shopify_client_id: shopifyY
            });
            if (IS_INTERNAL) {
              try {
                window.mixpanel.people.set({
                  is_internal: true,
                  internal_reason: TEAM_REGION ? 'shopify_region_vn' : 'hl_attr_sticky'
                });
              } catch (e) {}
            }
          } catch (e) {}

          if (DATA.customer) {
            // A logged-in shopper. distinct_id deliberately stays the Shopify
            // client id (switching it here would re-break the checkout join);
            // who they are is carried as profile fields instead.
            window.mixpanel.register({ customer_id: DATA.customer.id });
            window.mixpanel.people.set({
              $email: DATA.customer.email,
              $name: DATA.customer.name,
              customer_id: DATA.customer.id,
              orders_count: DATA.customer.orders_count,
              total_spent: DATA.customer.total_spent
            });
          }

          /* ---- Force the replay to upload when the visitor leaves ----
             The recorder batches every 10 seconds, so anyone who lands and
             leaves faster than that gets a replay ID on their events and NO
             viewable recording. Measured on a real visitor from Denver: 10
             seconds on site, replay id ce9dfb11, zero recording chunks.

             stop_session_recording() forces the pending buffer out. Verified
             both halves before shipping:
               - a ~3s visit now produces a recording chunk (it did not before);
               - three pages in a row still share ONE replay id, so this does
                 not chop a browsing session into one replay per page.

             visibilitychange is handled as well as pagehide because iOS often
             backgrounds a tab without ever firing pagehide — and recording is
             resumed on the way back, otherwise a tab-switch would silently end
             the recording for the rest of the visit. */
          function flushReplay() {
            try { window.mixpanel.stop_session_recording(); } catch (e) {}
          }
          window.addEventListener('pagehide', function () { launch(); flushReplay(); });
          document.addEventListener('visibilitychange', function () {
            try {
              if (document.visibilityState === 'hidden') { launch(); flushReplay(); }
              else if (human) startReplay();
            } catch (e) {}
          });

          /* ---- Record people, not bots ----
             Recording starts on the first TRUSTED input: pointerdown, touchstart,
             keydown, wheel, or a few mouse movements. Scroll is not on the list —
             a script can scroll a page, it cannot produce a trusted wheel or
             touch. Once a tab has proved human, sessionStorage remembers it, so
             the next page records from its first frame and waits for the id
             exactly as before.

             The replay id is also written to the hl_rp cookie, where the
             checkout pixel picks it up: add_to_cart, begin_checkout and purchase
             come from that pixel, and without the id they cannot be opened as a
             replay (0 of 186, 0 of 52 and 0 of 8 had one, 13/09–12/10). */
          var HUMAN_KEY = 'hl_human';
          var human = false;
          try { human = sessionStorage.getItem(HUMAN_KEY) === '1'; } catch (e) {}
          var NO_REPLAY = IS_CRAWLER || IS_AUTOMATED || TEAM_REGION;
          function shareReplayId(tries) {
            var rp = replayProps();
            if (rp) {
              try {
                document.cookie = 'hl_rp=' + encodeURIComponent(rp.$mp_replay_id) +
                                  ';path=/;max-age=1800;SameSite=Lax';
              } catch (e) {}
              return;
            }
            if (tries < 50) setTimeout(function () { shareReplayId(tries + 1); }, 200);
          }
          function startReplay() {
            // TEAM_REGION can turn true after boot (late region answer): no replay then.
            if (NO_REPLAY || TEAM_REGION) return;
            REPLAY_ON = true;
            try { window.mixpanel.start_session_recording(); } catch (e) {}
            shareReplayId(0);
          }
          var HUMAN_EVENTS = ['pointerdown', 'touchstart', 'keydown', 'wheel', 'mousemove'];
          var moves = 0;
          function onInput(e) {
            if (!e.isTrusted) return;
            if (e.type === 'mousemove' && ++moves < 3) return;
            for (var j = 0; j < HUMAN_EVENTS.length; j++) {
              window.removeEventListener(HUMAN_EVENTS[j], onInput, true);
            }
            human = true;
            try { sessionStorage.setItem(HUMAN_KEY, '1'); } catch (err) {}
            startReplay();
          }
          if (human) startReplay();
          else if (!NO_REPLAY) {
            for (var k = 0; k < HUMAN_EVENTS.length; k++) {
              window.addEventListener(HUMAN_EVENTS[k], onInput, { capture: true, passive: true });
            }
          }

          /* ---- wait for the replay id before the first event ----
             $mp_replay_id is what turns a row in a report into a video: it is
             the join between an event and its recording. The SDK attaches it to
             every event tracked AFTER the recorder has started, and the
             recorder is a second script that has to download first.

             Measured over 30 days: 116 of 116 page_views had no $mp_replay_id,
             because page_view was tracked in the same tick as init(). Later
             events did have one — 8 of 14 scroll_depth, 12 of 50
             product_image_view — which is exactly the signature of a race, not
             of replay being off.

             So the first event now waits for the id, but never for long, and
             never past the visitor leaving:
               - poll every 100ms, give up after 1200ms and send anyway;
               - pagehide / tab-hidden launches immediately (above), so a
                 two-second bounce still reports its page_view.
             Everything queued from the gtag wrapper flushes at the same moment,
             so those events get the id too. */
          var launched = false;
          function replayProps() {
            try {
              var p = window.mixpanel.get_session_recording_properties &&
                      window.mixpanel.get_session_recording_properties();
              return (p && p.$mp_replay_id) ? p : null;
            } catch (e) { return null; }
          }
          function launch() {
            if (launched || blocked) return;
            launched = true;
            ready = true;
            try {
              var rp = replayProps();
              if (rp) window.mixpanel.register(rp);
            } catch (e) {}
            try {
              var pv = {
                content_group: group(),
                page_path: location.pathname,
                page_title: document.title,
                referrer: document.referrer || '(direct)'
              };
              /* Added only when the page has one, exactly as the Liquid condition
                 did: an absent key and a '(none)' key do not mean the same thing
                 in a Mixpanel breakdown. */
              if (DATA.product_handle) pv.product_handle = DATA.product_handle;
              if (DATA.collection_handle) pv.collection_handle = DATA.collection_handle;
              window.mixpanel.track('page_view', withScope(pv));
            } catch (e) {}
            for (var i = 0; i < queue.length; i++) {
              try { window.mixpanel.track(queue[i][0], withScope(queue[i][1])); } catch (e) {}
            }
            queue.length = 0;
          }

          var waited = 0;
          (function waitForReplay() {
            if (launched) return;
            // Nothing to wait for until the visitor has proved human, nor for a
            // device that never records (team, crawler, automation).
            if (!human || NO_REPLAY || replayProps() || waited >= 1200) return launch();
            waited += 100;
            setTimeout(waitForReplay, 100);
          })();
        } catch (e) {
          blocked = true;
          queue.length = 0;
        }
      })();
    }

    /* The region answer arrived after the fallback already booted without it.
       Apply it rather than ignore it: a VN device is marked internal from here
       on (super property, profile, hl_attr cookie i = 1) and its replay is
       stopped and cannot restart; any other region is just recorded. Events
       sent before this point stay as they were sent. Never throws. */
    function lateRegion(cp) {
      if (!BOOTED || blocked || SHOP_REGION) return;
      var region = null;
      try { region = (cp && typeof cp.getRegion === 'function' && cp.getRegion()) || null; } catch (e) {}
      if (!region) return;
      SHOP_REGION = region;
      var team = hlIsTeamRegion(region);
      try {
        if (!team) { window.mixpanel.register({ shop_region: region }); return; }
        TEAM_REGION = true;
        IS_INTERNAL = true;
        window.mixpanel.register({ internal: true, shop_region: region });
        try { window.mixpanel.people.set({ is_internal: true, internal_reason: 'shopify_region_vn' }); } catch (e) {}
        var did = null, dev = null;
        try { did = typeof window.mixpanel.get_distinct_id === 'function' ? window.mixpanel.get_distinct_id() : null; } catch (e) {}
        try { dev = typeof window.mixpanel.get_property === 'function' ? window.mixpanel.get_property('$device_id') : null; } catch (e) {}
        publishAttr(trafficProps(), did, true, dev ? String(dev) : null);
        if (REPLAY_ON) { try { window.mixpanel.stop_session_recording(); } catch (e) {} }
      } catch (e) {}
    }

    withPrivacy(function (cp) {
      try { SHOP_REGION = (cp && typeof cp.getRegion === 'function' && cp.getRegion()) || null; } catch (e) {}
      TEAM_REGION = hlIsTeamRegion(SHOP_REGION);
      consentDecision(cp, boot);
    }, lateRegion);
  })();
